// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"e135c43a","336":"8567844f","382":"50540dc4","453":"c2ade7a5","651":"1dc1fd52"}[chunkId] + ".css";
};